import { createAction } from '@reduxjs/toolkit';
import { RequestError, Circulations, GetCirculationFilters } from 'types';
import { CirculationsState } from './types';

interface CirculationsWithTimestamp extends Circulations {
  searchTimestamp: string;
}

export const fetchCirculations = createAction('circulations/fetch', (filters: GetCirculationFilters) => ({
  payload: filters,
}));

export const fetchedCirculations = createAction(
  'circulations/fetched',
  (data?: CirculationsWithTimestamp, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const refreshCirculations = createAction(
  'circulations/refresh',
  (filters: Omit<GetCirculationFilters, 'weekdays'>) => ({
    payload: filters,
  })
);

export const refreshedCirculations = createAction(
  'circulations/refreshed',
  (data?: CirculationsWithTimestamp, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const exportCirculations = createAction(
  'circulations/export',
  (filters: Omit<GetCirculationFilters, 'weekdays'>, language: string) => ({
    payload: filters,
    meta: { language },
  })
);

export const exportedCirculations = createAction(
  'circulation-list/exported',
  (data?: ArrayBuffer, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const setShoudUsePersistedCirculationsFilters = createAction(
  'circulation-list/setShoudUsePersistedCirculationsFilters',
  (shoudUsePersistedFilter?: CirculationsState['shoudUsePersistedCirculationsFilters']) => ({
    payload: shoudUsePersistedFilter,
  })
);

export const setPersistedCirculationsFilters = createAction(
  'circulation-list/setPersistedCirculationsFilters',
  (data?: CirculationsState['persistedCirculationsFilters']) => ({
    payload: data,
  })
);

export default {
  fetchedCirculations,
  fetchCirculations,
  refreshCirculations,
  refreshedCirculations,
  exportCirculations,
  exportedCirculations,
  setShoudUsePersistedCirculationsFilters,
  setPersistedCirculationsFilters,
};
